import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { browserLanguage, createI18n, loadLanguage } from './i18n/index.ts';
import { installGlobalErrorReporting } from './shell/errors.tsx';
import { installVitals } from './shell/vitals.ts';
import './index.css';

const pseudo = new URLSearchParams(window.location.search).has('pseudo');
const language = browserLanguage();
const i18n = createI18n('en', { pseudo });
document.documentElement.lang = language;
installGlobalErrorReporting();
installVitals();
await loadLanguage(i18n, language);

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App i18n={i18n} />
    </StrictMode>,
  );
}
